import _ from 'lodash';

export const isHubspotFormSubmitted = (id, contact) => {
  if (
    contact &&
    contact['form-submissions'] &&
    contact['form-submissions'].length > 0
  ) {
    if (
      _.find(contact['form-submissions'], function(form) {
        return form['form-id'] === id;
      })
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};
